<script setup>
import { tableRecipe } from './table.recipe';
import { useTableContext } from './useTable';

/**
 * @typedef {import('./table.recipe').TableRecipeVariants} TableRecipeVariants
 */

/**
 * @typedef {object} TableHeaderProps
 * @property {TableRecipeVariants['variantBg']} [variantBg='surface'] - The background variant of the table header.
 */

/**
 * @type {TableHeaderProps}
 */
const props = defineProps({
  variantBg: {
    type: String,
    default: 'surface',
  },
});

const { header } = tableRecipe();
const { rootProps } = useTableContext();
</script>

<template>
  <thead
    data-component="CsTableHeader"
    :class="header({ ...props, ...rootProps })"
  >
    <slot />
  </thead>
</template>
